export default {
  sk: {
    data: {
      loading: 'Načítavam',
      error: 'Chyba'
    },
    pagination: {
      page_size: 'Veľkosť stránky',
      page_title: 'Zobraziť stránku',
      first: 'Prvá',
      first_title: 'Prvá stránka',
      last: 'Posledná',
      last_title: 'Posledná stránka',
      prev: 'Predošlá',
      prev_title: 'Predošlá stránka',
      next: 'Nasledujúca',
      next_title: 'Nasledujúca stránka',
      all: 'Všetky',
      counter: {
        showing: 'Zobrazenie',
        of: 'z',
        rows: 'riadkov',
        pages: 'stránok'
      }
    }
  }
}
